// Finar rev-B 3 — formüllü (ƒx) hücre hover/odak kartı: gösterge açıklaması (varsa) + aktif formül.
// Hafif ipucu (`role="tooltip"`); tıklamayla açılan FormulaPopover (girdiler, neden, notlar) aynen
// kalır. `document.body`'ye portal + `position:fixed` (use-popover-placement) — tablo kabı kırpmaz,
// grid düzeni kaymaz; `pointer-events:none` (imleç kartın üstüne gelince hücreden ayrılmış sayılmaz).
// İçerik saf `formulaHoverContent`'ten (portal maskesi FormulaPopover ile tek kaynak).

import { useRef } from "react";
import { createPortal } from "react-dom";
import type { FormulaHoverContent } from "../../lib/kpi-formula-hover";
import { placementStyle, usePopoverPlacement } from "./use-popover-placement";

export const FORMULA_HOVER_ID = "kpi-formula-hover";

export function FormulaHoverCard(props: {
  content: FormulaHoverContent;
  getAnchor: () => HTMLElement | null;
}): JSX.Element {
  const { content: c, getAnchor } = props;
  const rootRef = useRef<HTMLDivElement>(null);
  const pos = usePopoverPlacement(rootRef, getAnchor, []);
  return createPortal(
    <div
      ref={rootRef}
      id={FORMULA_HOVER_ID}
      role="tooltip"
      data-testid="kpi-formula-hover"
      className="rounded-lg px-3 py-2 text-xs"
      style={{
        ...placementStyle(pos),
        maxWidth: 340,
        pointerEvents: "none",
        fontFamily: "var(--font-sans)",
        background: "var(--color-surface)",
        border: "1px solid var(--color-border)",
        boxShadow: "var(--shadow-md, 0 12px 32px rgba(15,42,82,.18))",
        color: "var(--color-text-2)",
        overflowWrap: "anywhere",
        lineHeight: 1.5,
      }}
    >
      <div className="font-semibold" style={{ color: "var(--color-text)" }}>
        {c.title}
      </div>
      {c.description ? (
        <div className="mt-1" style={{ whiteSpace: "pre-wrap" }}>
          {c.description}
        </div>
      ) : null}
      {c.tokens ? (
        <div className="mt-1">
          <b>{c.formulaHeading}</b>
          {c.formulaLabel ? ` (${c.formulaLabel})` : ""}:{" "}
          {c.raw ? (
            <code style={{ fontFamily: "var(--font-mono)", fontSize: "0.76rem" }}>
              {c.tokens.map((t) => t.text).join("")}
            </code>
          ) : (
            <span data-testid="kpi-formula-hover-expression" style={{ color: "var(--color-text)" }}>
              {c.tokens.map((t, i) =>
                t.ref ? (
                  <span key={i} style={{ fontWeight: 600 }}>
                    {t.text}
                  </span>
                ) : (
                  <span key={i}>{t.text}</span>
                ),
              )}
            </span>
          )}
        </div>
      ) : (
        <div className="mt-1" style={{ color: "var(--color-warning-text)" }}>
          {c.noFormulaText}
        </div>
      )}
      <div className="mt-1" style={{ color: "var(--color-text-3)" }}>
        {c.moreText}
      </div>
    </div>,
    document.body,
  );
}
